<template>
    <div>
      <div class="flex flex-wrap justify-between items-center mb-4">
        <h5>Address</h5>
      </div>
      <div class="table-responsive">
        <table class="light_blue_table w-full">
          <tbody>
            <tr>
              <td>
                <div class="flex items-center">
                  <span class="material-icons-outlined small_icon">place</span>
                </div>
              </td>
              <td v-if="haveAddress()">
                {{ clientDetails.basic_details.address.address1 ? clientDetails.basic_details.address.address1 : ""
                }}{{  clientDetails.basic_details.address.address2 ? "," +  clientDetails.basic_details.address.address2 : "" }}
                {{  clientDetails.basic_details.address.city ? "," +  clientDetails.basic_details.address.city : "" }}
                {{  clientDetails.basic_details.address.state ? "," +  clientDetails.basic_details.address.state : "" }}
                {{  clientDetails.basic_details.address.zip ?  clientDetails.basic_details.address.zip : ""
                }}{{
                    clientDetails.basic_details.address.platform_customer_countries_id
                    ? "," + getCountry( clientDetails.basic_details.address.platform_customer_countries_id)
                    : ""
                }}
              </td>
              <td v-if="!haveAddress()">
                Not Available
              </td>
              <td class="text-right">
                <vs-dropdown>
                  <vs-button
                    class="btn-drop"
                    type="flat"
                    icon="more_vert"
                  ></vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item
                      :disabled="!checkEditPermission"
                      @click="handleedit"
                    >
                      Edit
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <vs-popup
        classContent="popup-example"
        title="Edit Address"
        :active.sync="editpopup"
      >
        <form data-vv-scope="edit">
          <vs-row>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input
                name="address1"
                v-model="edit.address1"
                class="custom_Input"
                label="Address Line 1"
                icon-pack="feather"
                icon="icon-edit"
                icon-after
                style="width: 100%"
              />
              <span v-show="errors.has('edit.address1')" class="text-danger">{{
                errors.first("edit.address1")
              }}</span>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input
                v-model="edit.address2"
                class="custom_Input"
                label="Address Line 2"
                icon-pack="feather"
                icon="icon-edit"
                icon-after
                style="width: 100%"
              />
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input
                name="city"
                v-model="edit.city"
                label="City"
                icon-pack="feather"
                icon="icon-edit"
                icon-after
                style="width: 100%"
              />
              <span v-show="errors.has('edit.city')" class="text-danger">{{
                errors.first("edit.city")
              }}</span>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input
                name="zip"
                v-model="edit.zip"
                class="custom_Input"
                label="Postcode/Zip"
                icon-pack="feather"
                icon="icon-edit"
                icon-after
                style="width: 100%"
              />
              <span v-show="errors.has('edit.zip')" class="text-danger">{{
                errors.first("edit.zip")
              }}</span>
            </vs-col>
            <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input
                name="state"
                v-model="edit.state"
                class="custom_Input"
                label="County/State"
                icon-pack="feather"
                icon="icon-edit"
                icon-after
                style="width: 100%"
              />
              <span v-show="errors.has('edit.state')" class="text-danger">{{
                errors.first("edit.state")
              }}</span>
            </vs-col>
            <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
              <label class="vs-input--label">Country</label>
              <v-select
                v-model="edit.platform_customer_countries_id"
                :reduce="(option) => option.id"
                label="country_name"
                name="Country"
                :options="countryList"
                style="width: 100%"
              />
              <span v-show="errors.has('edit.Country')" class="text-danger">{{
                errors.first("edit.Country")
              }}</span>
            </vs-col>
          </vs-row>
        </form>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
          <vs-button class="mr-2" @click.prevent="handleUpdate">Save</vs-button>
          <vs-button type="border" color="danger" @click="editpopup = false"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
    </div>
  </template>
<script>
import { GetCountryList } from '@/api/common'
import { StudentMixins } from '@/views/pages/v1/StudentProfile/mixins/studentMixin.js'

import vSelect from 'vue-select'
export default {
  name: 'address',
  components: {
    vSelect
  },
  props: {
    clientDetails: {
      required: true,
      type: Array,
      default: () => []
    },
    checkEditPermission:{
      default: false
    }
  },
  mixins: [StudentMixins],
  data () {
    return {
      countryList: [],
      editpopup: false,
      edit: {
        address1: '',
        address2: '',
        city: '',
        id: '',
        state: '',
        zip: '',
        defaults: 0
      }
    }
  },
  mounted () {
    this.fetchCountry()
  },
  methods: {
    haveAddress () {
      if (this.clientDetails.basic_details.address.address1) return true
      else if (this.clientDetails.basic_details.address.address2) return true
      else if (this.clientDetails.basic_details.address.city) return true
      else if (this.clientDetails.basic_details.address.state) return true
      else if (this.clientDetails.basic_details.address.zip) return true
      else if (this.clientDetails.basic_details.address.platform_customer_countries_id) return true
      else return false
    },
    async fetchCountry () {
      try {
        const { data } = await GetCountryList()
        this.countryList = data.data.countries_list
      } catch (e) {
        console.log(e)
      }
    },
    handleedit () {
      if (this.clientDetails.basic_details.active_user === '0') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as student is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.editpopup = true
      this.edit = this.clientDetails.basic_details.address
    },
    handleUpdate () {
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          this.clientDetails.basic_details.address = this.edit
          this.UpdateDetails(this.clientDetails.basic_details.client_users_id)
          this.editpopup = false
          this.$emit('userUpdated', true)
        }
      })
    },
    getCountry (id) {
      if (id) {
        const index = this.countryList.findIndex((item) => item.id === id)
        return this.countryList[index].country_name
      } else {
        return 'not available'
      }
    }
  }
}
</script>
